import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaCoffee, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaMapMarkerAlt, FaUtensils, FaWifi } from 'react-icons/fa';

const WebCafeteriaPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-restaurantes", text: "Página web barata para restaurantes" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Atrae clientes mientras preparas café",
      description: "Tu web trabaja 24/7, captando clientes potenciales incluso fuera del horario de apertura. Presenta tu propuesta y ambiente antes de que visiten tu cafetería."
    },
    {
      title: "Diferénciate de la competencia",
      description: "El 68% de las cafeterías aún no tienen presencia online profesional. Destaca con una web que muestre tu personalidad y propuesta única."
    },
    {
      title: "Posiciónate por encima de cadenas",
      description: "Una web optimizada localmente permite a cafeterías independientes competir con grandes cadenas en las búsquedas de Google por la zona."
    },
    {
      title: "Muestra tu ambiente y especialidades",
      description: "Las fotos de tu local, bebidas y platos generan el deseo de visita. Un 72% de clientes deciden dónde ir basándose en las imágenes que ven online."
    },
    {
      title: "Información accesible 24/7",
      description: "Horarios, ubicación, menú y eventos especiales disponibles siempre. Reduce llamadas informativas y facilita la decisión de visita."
    },
    {
      title: "Retorno de inversión rápido",
      description: "Con solo 5-6 nuevos clientes semanales que lleguen por la web, recuperas la inversión en menos de dos meses. Después todo son beneficios."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaCoffee />,
      title: "Carta digital atractiva",
      description: "Presentación visual de tus cafés, bebidas y platos con descripciones apetitosas. Precios actualizables fácilmente desde el panel de administración."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño 100% adaptado a móviles",
      description: "El 82% de las búsquedas de cafeterías se hacen desde el móvil. Tu web se verá perfecta en cualquier dispositivo, manteniendo la navegación intuitiva."
    },
    {
      icon: <FaUtensils />,
      title: "Galería de productos y ambiente",
      description: "Muestra tus especialidades y el ambiente de tu local con fotografías profesionales que inviten a la visita. Primera impresión impecable."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización local avanzada",
      description: "Configuración para Google Maps y Google Business Profile. Destaca cuando busquen cafeterías cercanas con toda tu información actualizada."
    },
    {
      icon: <FaWifi />,
      title: "Información de servicios adicionales",
      description: "Destaca tus servicios como WiFi, enchufes, espacio de trabajo, terraza o eventos especiales. Atrae al tipo de cliente que buscas."
    },
    {
      icon: <FaSearch />,
      title: "SEO específico para cafeterías",
      description: "Posicionamiento para términos como 'cafetería en [tu zona]' o tus especialidades. Optimización de contenidos para atraer a tu cliente ideal."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web Cafetería Básica',
      price: 200,
      period: 'pago único',
      description: 'Ideal para cafeterías independientes que quieren iniciar su presencia digital profesional.',
      features: [
        { text: 'Hasta 5 páginas principales', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carta digital básica', included: true },
        { text: 'Formulario de contacto', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Información de horarios y ubicación', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Galería de fotos básica', included: true },
        { text: 'Sistema de pedidos online', included: false },
        { text: 'Optimización SEO avanzada', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=cafeteria-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Cafetería Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más elegida. Web completa con todas las funcionalidades para cafeterías que quieren destacar.',
      features: [
        { text: 'Entre 5-10 páginas', included: true },
        { text: 'Adaptada a todos los dispositivos', included: true },
        { text: 'Carta digital completa con imágenes', included: true },
        { text: 'Galería de fotos profesional', included: true },
        { text: 'Blog para eventos y novedades', included: true },
        { text: 'Integración con redes sociales', included: true },
        { text: 'Sección de eventos y promociones', included: true },
        { text: 'Optimización SEO local', included: true },
        { text: 'Sistema de pedidos online*', included: false },
        { text: 'Configuración Google Business Profile', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=cafeteria-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Cafetería Premium',
      price: 400,
      period: 'pago único',
      description: 'Solución completa para cafeterías que buscan una experiencia digital premium para sus clientes.',
      features: [
        { text: 'Entre 10-15 páginas', included: true },
        { text: 'Diseño exclusivo personalizado', included: true },
        { text: 'Carta premium interactiva', included: true },
        { text: 'Sección de historia y valores', included: true },
        { text: 'Galería profesional con categorías', included: true },
        { text: 'Multiidioma (2 idiomas)', included: true },
        { text: 'Blog con contenido inicial', included: true },
        { text: 'Estrategia SEO completa', included: true },
        { text: 'Sistema de pedidos online avanzado*', included: false },
        { text: 'Marketing digital inicial', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=cafeteria-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu cafetería, especialidades y ambiente. Planificamos una web que refleje tu esencia y conecte con tus clientes ideales.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño atractivo que transmita la experiencia de tu cafetería. Implementamos todas las secciones y funcionalidades necesarias.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO local para que te encuentren los clientes de tu zona.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para cafeterías",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Carta digital fácil de actualizar",
      us: true,
      others: false
    },
    {
      label: "Fotos profesionales optimizadas",
      us: true,
      others: false
    },
    {
      label: "Sin comisiones por pedidos online",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Antes solo contábamos con Instagram y una ficha de Google. Desde que lanzamos nuestra web profesional, hemos notado un incremento significativo en nuevos clientes, especialmente turistas y profesionales que buscan un lugar para trabajar. La web nos permite mostrar nuestro ambiente, especialidades y eventos de una forma que no es posible en redes sociales. La inversión se recuperó en menos de dos meses y ahora es nuestra principal herramienta de marketing digital.",
    author: "Miguel Torres",
    position: "Propietario",
    company: "Café Aroma",
    avatar: "/servicios/testimonios/cafeteria.webp"
  };
  
  const founderMessage = "En el mundo de las cafeterías, el ambiente y la experiencia son tan importantes como la calidad del café. Diseñamos webs que transmiten la esencia y personalidad única de cada local, destacando tanto sus especialidades como el entorno que ofrecen. Una cafetería con presencia online efectiva puede diferenciar su propuesta y atraer clientes más allá del radio tradicional de su barrio.";
  
  // FAQs específicas para web de cafeterías
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional para mi cafetería?",
      answer: "Una web profesional es fundamental para las cafeterías actuales por varios motivos estratégicos: 1) El 78% de los clientes buscan cafeterías online antes de decidir dónde ir; 2) Muestra tu ambiente, especialidades y personalidad, diferenciándote de grandes cadenas; 3) Te posiciona en Google Maps y búsquedas locales, fundamental para captar clientes de proximidad; 4) Proporciona información básica (horarios, ubicación, carta) 24/7, reduciendo llamadas informativas; 5) Permite destacar tus servicios adicionales (WiFi, enchufes, espacios de trabajo) para atraer un perfil específico de cliente; 6) Facilita la comunicación de eventos especiales, promociones o novedades; 7) Complementa tus redes sociales con información más completa y organizada. Según estudios del sector, las cafeterías con presencia web profesional incrementan su afluencia entre un 20-30% en los primeros seis meses, especialmente de nuevos clientes y perfiles de mayor valor (como profesionales que trabajan remotamente o turistas).",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se mostrará mi carta en la web?",
      answer: "Tu carta se presentará de forma visual y atractiva con estas características: 1) Organización por categorías (cafés, bebidas frías, desayunos, platos, etc.) para facilitar la navegación; 2) Imágenes profesionales de tus productos más destacados; 3) Descripciones apetitosas que destaquen ingredientes, origen o preparación; 4) Indicadores visuales para opciones vegetarianas, veganas o sin gluten; 5) Precios claramente visibles; 6) Diseño responsive que asegura perfecta visualización en móviles; 7) Posibilidad de destacar especialidades o recomendaciones. Además, te proporcionamos acceso a un panel de administración intuitivo para que puedas actualizar fácilmente precios o modificar la carta cuando incluyas nuevos productos. Para cafeterías con carta que cambia frecuentemente (menú del día, platos de temporada), podemos implementar secciones específicas fácilmente actualizables o incluso conectar con tus redes sociales para mostrar novedades en tiempo real.",
      category: "Contenidos"
    },
    {
      question: "¿Incluís un sistema de pedidos online?",
      answer: "Los sistemas de pedidos online no están incluidos en los precios base de los planes y se presupuestan aparte según tus necesidades específicas: 1) Sistema básico de pedidos para recoger (desde 100€) - Formulario con selección de productos y hora de recogida; 2) Sistema intermedio con pago online (desde 250€) - Carta interactiva con carrito de compra y pasarela de pago integrada; 3) Sistema avanzado con delivery (desde 400€) - Plataforma completa con gestión de zonas de entrega, tiempos y seguimiento de pedidos. Estos sistemas son complementos opcionales que se adaptan a tus procesos de trabajo, sin comisiones por ventas (a diferencia de plataformas como Just Eat o Glovo que cobran entre 15-30% por pedido). También podemos integrar tu web con plataformas externas si ya trabajas con alguna. La implementación del sistema de pedidos requiere configuración específica según tu modelo de negocio, por lo que se presupuesta individualmente tras analizar tus requerimientos exactos.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, carta, galería, sobre nosotros y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, añadiendo secciones como blog, eventos, promociones especiales, o páginas detalladas por tipos de productos; 3) El plan Premium (400€) permite entre 10-15 páginas, pudiendo añadir multiidioma, historia del café, información sobre tostadores, cursos y talleres, etc. Si necesitas más páginas de las incluidas en tu plan, estas tienen un coste adicional de 40€ por página. Para webs realmente extensas con más de 15 páginas, recomendamos solicitar un presupuesto personalizado. Es importante destacar que la mayoría de cafeterías consiguen excelentes resultados con el número de páginas incluido en los planes estándar, ya que lo importante es la calidad de las imágenes y la organización del contenido, no la cantidad de páginas.",
      category: "Planes"
    },
    {
      question: "¿Qué fotos utilizaréis en mi web?",
      answer: "Las imágenes son cruciales para una web de cafetería efectiva. Tienes estas opciones: 1) Fotografías propias: Si dispones de imágenes profesionales de tu local, productos y ambiente, las optimizaremos para web manteniendo la calidad; 2) Sesión fotográfica profesional: Te recomendamos fotógrafos especializados en hostelería en varias ciudades (presupuesto aproximado: 200-300€ por sesión completa); 3) Imágenes mixtas: Combinación de tus mejores fotos actuales con algunas imágenes de stock seleccionadas; 4) Consejos fotográficos: Te proporcionamos una guía para que puedas tomar buenas fotos con tu smartphone hasta realizar una sesión profesional. Recomendamos especialmente invertir en fotografías profesionales de tus productos más destacados y del ambiente del local, ya que son determinantes para la primera impresión. Según estudios, las webs de cafeterías con fotografías profesionales generan un 170% más de visitas físicas que aquellas con imágenes de baja calidad o sin imágenes.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye: 1) Alojamiento en servidores de alta velocidad; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento. Te proporcionamos acceso a un panel intuitivo donde podrás actualizar fácilmente la carta, añadir eventos o promociones, subir nuevas fotos y modificar información básica como horarios. Para cafeterías, es especialmente útil poder actualizar rápidamente información estacional (terraza en verano, carta de invierno, horarios especiales en festivos). El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, asegurar la renovación del dominio y el alojamiento seguro de los contenidos.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para cafeterías
      pageTitle="Web para Cafeterías desde 200€ | Presencia Online Profesional"
      pageDescription="Diseño web especializado para cafeterías y coffee shops. Carta digital, galería de ambiente y productos, y presencia local para atraer más clientes a tu local."
      pageKeywords="página web barata cafetería, web para cafeterías, diseño web coffee shop, página web café barata, web cafetería económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-cafeteria"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para cafeterías desde 200€ (atrae clientes mientras preparas café)"
      heroSubtitle="Diseño web profesional para cafeterías y coffee shops. Muestra tu ambiente, especialidades y carta. Optimizada para atraer clientes de tu zona."
      heroImage="/servicios/tipo-cliente/hero-cafeteria.webp"
      badges={['Desde 200€ (pago único)', 'Carta digital atractiva', 'Optimizada para móviles', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para cafeterías y coffee shops"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades. Todos incluyen soporte técnico y mantenimiento por 20€/mes. *Sistemas de pedidos online presupuestados aparte."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para cafeterías?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Miguel Vela"
          founderTitle="Co-fundador y Director de Desarrollo"
          avatarSrc="/sobre nosotros/foto-miguel.webp"
        />
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de cafetería?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu cafetería"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para cafeterías"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu cafetería con presencia online profesional"
      ctaDescription="Una inversión inteligente que atraerá nuevos clientes, mostrará tu ambiente único y diferenciará tu cafetería de la competencia. Recupera la inversión en pocas semanas."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebCafeteriaPage; 

